import { render } from "./BannerSlideTwo.vue?vue&type=template&id=38967359&ts=true"
import script from "./BannerSlideTwo.vue?vue&type=script&lang=ts"
export * from "./BannerSlideTwo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__